/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PlaylistChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#createPlaylist
 */
export const CREATE_PLAYLIST_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_createPlaylist';
export const CREATE_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PLAYLIST_MUTATION_FIELD_NAME,
  args: ['items', 'name', 'description', 'thumbnailSquareUrl', 'thumbnailRectangleUrl'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPlaylistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#updatePlaylist
 */
export const UPDATE_PLAYLIST_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_updatePlaylist';
export const UPDATE_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_PLAYLIST_MUTATION_FIELD_NAME,
  args: ['playlistId', 'playlistUpdateRequest'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updatePlaylistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#getPlaylistById
 */
export const GET_PLAYLIST_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_getPlaylistById';
export const GET_PLAYLIST_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPlaylistByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#addPlaylistItem
 */
export const ADD_PLAYLIST_ITEM_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_addPlaylistItem';
export const ADD_PLAYLIST_ITEM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ADD_PLAYLIST_ITEM_MUTATION_FIELD_NAME,
  args: ['playlistId', 'playlistItemRequest'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.addPlaylistItemRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#deletePlaylistItem
 */
export const DELETE_PLAYLIST_ITEM_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_deletePlaylistItem';
export const DELETE_PLAYLIST_ITEM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PLAYLIST_ITEM_MUTATION_FIELD_NAME,
  args: ['playlistId', 'playlistItemRequest'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.deletePlaylistItemRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#savePlaylist
 */
export const SAVE_PLAYLIST_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_savePlaylist';
export const SAVE_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SAVE_PLAYLIST_MUTATION_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.savePlaylistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#unsavePlaylist
 */
export const UNSAVE_PLAYLIST_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_unsavePlaylist';
export const UNSAVE_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNSAVE_PLAYLIST_MUTATION_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.unsavePlaylistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_PlaylistChirpService_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['interactionTypes', 'query', 'limit', 'types', 'sortProperty', 'sortOrder', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});